// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__KqXG3","loader":"Layout_loader__rMuRN"};